import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, catchError, map } from 'rxjs';


import { JobsFilterResponse, JobsRequestModel, costddl, costddls, jobCostRequestModel, jobCostResponseModel, jobMilestonesRequestModel, jobMilestonesResponseModel, jobNotesResponse, jobsFinancialResponseModel, jobsNotesCommentsRequest, jobsNotesCommentsResponse, jobsResponseModel, jobsTaskResponseModel } from '../models/jobs';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';
import { StorageService } from 'src/app/shared/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  userProfile = new Subject();
  job_id: EventEmitter<string> = new EventEmitter<string>();
  private closeEventSubject = new Subject<any>();
  closeEvent$ = this.closeEventSubject.asObservable();

  private selectedNotes = new Subject<any>();

  constructor(
    private httpClient: HttpClient,
    private storage_service: StorageService,
  ) { }

  set_jobId(value: any) {
    if (value !== undefined) {
      return this.job_id.emit(value);
    }
  }

  emitCloseEvent(data: any) {
    this.closeEventSubject.next(data);
  }

  jobsList(page: number, limit: number, searchValue: any, tab: number, sub_tab: number, client_id: string, state_id: number, priority_id: number, staff_id: number, job_manager_id: number, account_manager_id: number, category_id: number, start_from_date: any, end_from_date: any, start_due_date: any, end_due_date: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist + `?page=${page}&limit=${limit}&search_value=${searchValue}&tab=${tab}&sub_tab=${sub_tab}&client_id=${client_id}&state_id=${state_id}&priority_id=${priority_id}&staff_id=${staff_id}&job_manager_id=${job_manager_id}&account_manager_id=${account_manager_id}&category_id=${category_id}&start_from_date=${start_from_date}&end_from_date=${end_from_date}&start_due_date=${start_due_date}&end_due_date=${end_due_date}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  exportJobsList(): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsmyList(page: number, limit: number, searchValue: any, tab: number, sub_tab: number, client_id: string, state_id: any, priority_id: any, staff_id: any, job_manager_id: any, account_manager_id: any, category_id: any, start_from_date: any, end_from_date: any, start_due_date: any, end_due_date: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist + `?page=${page}&limit=${limit}&search_value=${searchValue}&tab=${tab}&sub_tab=${sub_tab}&client_id=${client_id}&state_id=${state_id}&priority_id=${priority_id}&staff_id=${staff_id}&job_manager_id=${job_manager_id}&account_manager_id=${account_manager_id}&category_id=${category_id}&start_from_date=${start_from_date}&end_from_date=${end_from_date}&start_due_date=${start_due_date}&end_due_date=${end_due_date}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  // jobs_managingList(page: number, limit: number ,tab:string, searchValue: any): Observable<jobsResponseModel> {
  //   return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist + `?page=${page}&limit=${limit}&tab=${tab}&search_value=${searchValue}`).pipe(
  //     map((response: jobsResponseModel) =>
  //       response
  //     ),
  //     catchError((error: jobsResponseModel) => {
  //       throw new Error('Something went wrong. Please try again later.');
  //     })
  //   );
  // }

  jobs_archiveList(page: number, limit: number, tab: string, state: any, date_type: any, from_date: any, to_date: any, client: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist + `?page=${page}&limit=${limit}&tab=${tab}&state=${state}&date_type=${date_type}&from_date=${from_date}&to_date=${to_date}&client=${client}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjob(id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist + id + '/').pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtask(page: number, limit: number, id: any, phase_id: any, is_phase: any, job_task_order_id: any): Observable<jobsTaskResponseModel> {
    if (is_phase) {
      return this.httpClient.get<jobsTaskResponseModel>(apiEndpoints.jobstasklist + `?page=${page}&limit=${limit}&job_id=${id}&phase_id=${phase_id}`).pipe(
        map((response: jobsTaskResponseModel) =>
          response
        ),
        catchError((error: jobsResponseModel) => {
          throw new Error('Something went wrong. Please try again later.');
        })
      );
    } else {
      return this.httpClient.get<jobsTaskResponseModel>(apiEndpoints.jobstasklist + `?page=${page}&limit=${limit}&job_id=${id}&job_task_order_id=${job_task_order_id}`).pipe(
        map((response: jobsTaskResponseModel) =>
          response
        ),
        catchError((error: jobsResponseModel) => {
          throw new Error('Something went wrong. Please try again later.');
        })
      );
    }
  }

  jobtaskdetails(task_id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstasklist + task_id + '/').pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }


  updatetask(id: any, job_task_request: JobsRequestModel): Observable<jobsResponseModel> {
    return this.httpClient.put<jobsResponseModel>(apiEndpoints.jobstasklist + id + '/', job_task_request).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjobs_taskAmount(job_task_id: any, postData: any): Observable<jobsResponseModel> {
    return this.httpClient.patch<jobsResponseModel>(apiEndpoints.jobstasklist + job_task_id + `/`, postData).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateJobStaffRate(job_id: any, postData: any): Observable<jobsResponseModel> {
    return this.httpClient.patch<jobsResponseModel>(apiEndpoints.jobslist + job_id + `/`, postData).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  UpdateStaffJobRate(data: any): Observable<any[]> {
    return this.httpClient.post<any[]>(apiEndpoints.job_staff_billing_rates, data).pipe(
      map((response: any[]) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getStaffJobRate(job_id: string, page: any, limit: any): Observable<any[]> {
    return this.httpClient.get<any[]>(apiEndpoints.job_staff_billing_rates + `?job_id=${job_id}&page=${page}&limit=${limit}`).pipe(
      map((response: any[]) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateCost(id: any, job_cost_request: jobCostRequestModel): Observable<jobCostResponseModel> {
    return this.httpClient.put<jobCostResponseModel>(apiEndpoints.deletecost + id + '/', job_cost_request).pipe(
      map((response: jobCostResponseModel) =>
        response
      ),
      catchError((error: jobCostResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createtask(job_task_request: JobsRequestModel): Observable<jobsResponseModel> {
    return this.httpClient.post<jobsResponseModel>(apiEndpoints.jobstasklist, job_task_request).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createCost(job_task_request: jobCostRequestModel): Observable<jobCostResponseModel> {
    return this.httpClient.post<jobCostResponseModel>(apiEndpoints.deletecost, job_task_request).pipe(
      map((response: jobCostResponseModel) =>
        response
      ),
      catchError((error: jobCostResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjob_taskDdl(pagination: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.task_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjobinfo(id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobslist + id + '/').pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createJob(job_type_request: JobsRequestModel): Observable<jobsResponseModel> {
    return this.httpClient.post<jobsResponseModel>(apiEndpoints.jobslist, job_type_request).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updatejob(id: any, job_type_request: JobsRequestModel): Observable<jobsResponseModel> {
    return this.httpClient.put<jobsResponseModel>(apiEndpoints.jobslist + id + '/', job_type_request).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  // task ToDO

  jobtodolist(page: number, limit: number, id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstodolist + `?page=${page}&limit=${limit}&job_task_id=${id}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  addtodotask(addtodo: JobsRequestModel): Observable<jobsResponseModel> {
    return this.httpClient.post<jobsResponseModel>(apiEndpoints.jobstodolist, addtodo).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  get_todo(job_task_todo_id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstodolist + job_task_todo_id + '/').pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updatetoDo(id: any, addtodo: JobsRequestModel): Observable<jobsResponseModel> {
    return this.httpClient.put<jobsResponseModel>(apiEndpoints.jobstodolist + id + '/', addtodo).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteTodo(job_task_todo_id: any, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobstodolist + job_task_todo_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteTask(job_task_id: any, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.deleteTask + job_task_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deletecost(job_cost_id: any, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.deletecost + job_cost_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  is_actual(job_cost_id: any, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.deletecost + job_cost_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtimesheetlist_all(data: any): Observable<jobsResponseModel> {
    const queryParams: any = {
      job_ids: data.job_id,
      page: data.page,
      limit: data.limit,
      tab: data.tab,
      staff_ids: data.staff_id,
      client_ids: data.client_id
    };
    if (data.status) {
      queryParams.status_id = data.status_id;
    } else {
      queryParams.invoice_status_id = data.invoice_status_id;
    }

    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist, { params: queryParams }).pipe(
      map((response: jobsResponseModel) => response),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }


  // jobtimesheetlist_all(data: any): Observable<jobsResponseModel> {
  //   if (data.status == 'Enable') {
  //     const enable_data = {
  //       job_id: data.job_id,
  //       page: data.page,
  //       limit: data.limit,
  //       tab: data.tab,
  //       status_id:data.status_id
  //     }
  //     return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist + `?job_id=${enable_data.job_id}&page=${enable_data.page}&limit=${enable_data.limit}&tab=${enable_data.tab}&status_id=${enable_data.status_id}`).pipe(
  //       map((response: jobsResponseModel) =>
  //         response
  //       ),
  //       catchError((error: jobsResponseModel) => {
  //         throw new Error('something went wrong. Please try again later.')
  //       })
  //     )
  //   } else {
  //     const disable_data = {
  //       job_id: data.job_id,
  //       page: data.page,
  //       limit: data.limit,
  //       tab: data.tab,
  //       invoice_status_id:data.invoice_status_id
  //     }
  //     return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist + `?job_id=${disable_data.job_id}&page=${disable_data.page}&limit=${disable_data.limit}&tab=${disable_data.tab}&status_id=${disable_data.invoice_status_id}`).pipe(
  //       map((response: jobsResponseModel) =>
  //         response
  //       ),
  //       catchError((error: jobsResponseModel) => {
  //         throw new Error('something went wrong. Please try again later.')
  //       })
  //     )
  //   }
  // }

  jobtimesheetlist_today(page: number, limit: number, id: any, tab: string): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist + `?job_id=${id}&page=${page}&limit=${limit}&tab=${tab}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtimesheetlist_thisweek(page: number, limit: number, id: any, tab: string): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist + `?job_id=${id}&page=${page}&limit=${limit}&tab=${tab}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtasktimesheetlist(data: any): Observable<jobsResponseModel> {

    const queryParams: any = {
      job_task_ids: data.job_task_id,
      page: data.page,
      limit: data.limit,
      tab: data.tab,
      staff_ids: data.staff_id,
      client_ids: data.client_id
    };
    if (data.status) {
      queryParams.status_id = data.status_id;
    } else {
      queryParams.invoice_status_id = data.invoice_status_id;
    }

    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist, { params: queryParams }).pipe(
      map((response: jobsResponseModel) => response),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  // jobtimesheetlist_all(data: any): Observable<jobsResponseModel> {
  //   const queryParams:any = {
  //     job_ids: data.job_id,
  //     page: data.page,
  //     limit: data.limit,
  //     tab: data.tab,
  //     staff_ids: data.staff_id,
  //     client_ids:data.client_id
  //   };
  //   if (data.status) {
  //     queryParams.status_id = data.status_id;
  //   } else {
  //     queryParams.invoice_status_id = data.invoice_status_id;
  //   }

  //   return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist, { params: queryParams }).pipe(
  //     map((response: jobsResponseModel) => response),
  //     catchError((error: any) => {
  //       throw new Error('Something went wrong. Please try again later.');
  //     })
  //   );
  // }

  jobtimesheetlisttask_today(id: any, page: number, limit: number, tab: string): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist + `?job_task_ids=${id}&page=${page}&limit=${limit}&tab=${tab}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  jobtimesheetlisttask_thisweek(id: any, page: number, limit: number, tab: string): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheetlist + `?job_task_ids=${id}&page=${page}&limit=${limit}&tab=${tab}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  addtimesheet(addtimesheet: any): Observable<jobsResponseModel> {
    return this.httpClient.post<jobsResponseModel>(apiEndpoints.jobstimesheet, addtimesheet).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  get_timesheet(timesheet_id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobstimesheet + timesheet_id + '/').pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updatetimesheet(id: any, job_timesheet_request: any): Observable<jobsResponseModel> {
    return this.httpClient.put<jobsResponseModel>(apiEndpoints.jobstimesheet + id + '/', job_timesheet_request).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteTimesheet(timesheet_id: any, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobstimesheet + timesheet_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsDDl(profile: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobsddl + `?user_profile_pk=${profile}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsTaskDDl(job: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobtask + `?job_id=${job}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobcostlist(data: any): Observable<jobsResponseModel> {
    const queryParams: any = {
      job_ids: data.job_id,
      page: data.page,
      limit: data.limit,
      staff_ids: data.staff_id || [],
      client_ids: data.client_id,
      tab: data.tab,
      job_cost_order_id: data.job_cost_order_id
    };
    if (data.phase) {
      queryParams.phase_id = data.phase_id
    }
    if (data.status) {
      queryParams.status_id = data.status_id;
    } else {
      queryParams.invoice_status_id = data.invoice_status_id;
    }
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobscost, { params: queryParams }).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  getcost(job_cost_id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobscost + job_cost_id + `/`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  getCostDdl(page: number, limit: number): Observable<costddls> {
    return this.httpClient.get<costddls>(apiEndpoints.cost_ddl + `?page=${page}&limit=${limit}`).pipe(
      map((response: costddls) =>
        response
      ),
      catchError((error: costddl) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobquoteslist(page: number, limit: number, id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_quotes + id + `/?page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  jobinvoiceslist(page: number, limit: number, id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_invoice + `?page=${page}&limit=${limit}&job_id=${id}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  // v2 job invoicelist

  jobInvoiceslist(page: number, limit: number, id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_v2_invoice + `?job_id=${id}&page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  jobpolist(page: number, limit: number, id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_po + id + `/?page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  delete_job(id: any, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobslist + id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  //jobs Document List

  jobsdocumentlist(job_id: string, page: number, limit: number): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_document + `?job_id=${job_id}&page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('something went wrong. Please try again later.');
      })
    )
  }

  jobsDocumentUpload(formData: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.jobs_document, formData).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('something went wrong. Please try again later.');
      })
    )
  }

  deletejobsDocument(document_id: string, data: any): Observable<any[]> {
    return this.httpClient.patch<any[]>(apiEndpoints.jobs_document + document_id + '/', data).pipe(
      map((response: any[]) =>
        response
      )
    );
  }

  jobsDocumentFolderList(job: string, page: number, limit: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_documents_folders + job + `/?page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsFolderDocumentList(job: string, id: any, page: number, limit: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_documents_folders_documents + job + `/` + id + `/?page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  //jobs notes list

  addjobNotes(notes: any): Observable<jobNotesResponse> {
    return this.httpClient.post<jobNotesResponse>(apiEndpoints.jobs_notes, notes).pipe(
      map((response: jobNotesResponse) =>
        response
      )
    );
  }

  updatejobNotes(notes: any, noteId: number): Observable<jobNotesResponse> {
    return this.httpClient.put<jobNotesResponse>(apiEndpoints.jobs_notes + noteId + `/`, notes).pipe(
      map((response: jobNotesResponse) =>
        response
      )
    );
  }

  jobNotesList(job: string, page: number, limit: number): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_notes + `?job_id=` + job + `&page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobNotesFolderList(job: string, page: number, limit: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_folder + job + `/?page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobFolderNotesList(job: string, id: any, page: number, limit: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_phase_notes + job + `/` + id + `/?page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getNoteInfo(notesId: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_notes + notesId + `/`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deletejobNotes(noteId: number, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobs_notes + noteId + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  //job task notes

  addjobtaskNotes(notes: any): Observable<jobNotesResponse> {
    return this.httpClient.post<jobNotesResponse>(apiEndpoints.jobs_task_notes, notes).pipe(
      map((response: jobNotesResponse) =>
        response
      )
    );
  }

  updatejobtaskNotes(notes: any, noteId: number): Observable<jobNotesResponse> {
    return this.httpClient.put<jobNotesResponse>(apiEndpoints.jobs_task_notes + noteId + `/`, notes).pipe(
      map((response: jobNotesResponse) =>
        response
      )
    );
  }

  jobtaskNotesList(jobtask: string, page: number, limit: number): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_task_notes + `?job_task_id=` + jobtask + `&page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtaskNotesFolderList(jobtask: string, page: number, limit: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_task_folder + jobtask + `/?page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtaskFolderNotesList(jobtask: string, id: any, page: number, limit: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_task_folder_notes + jobtask + `/` + id + `/?page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  gettaskNoteInfo(notesId: number): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobs_task_notes + notesId + `/`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deletejobtaskNotes(noteId: number, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobs_task_notes + noteId + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobUpdate(job_id: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobslist + job_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  //jobs-Notes-Comments
  notesAddComments(notes: jobsNotesCommentsRequest): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.post<jobsNotesCommentsResponse>(apiEndpoints.jobs_notes_comments, notes).pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updatejobNotesComments(job_notes_comments_id: number, notes: any): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.put<jobsNotesCommentsResponse>(apiEndpoints.jobs_notes_comments + job_notes_comments_id + `/`, notes).pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getNotesComments(job_notes_comments_id: jobsNotesCommentsResponse): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.get<jobsNotesCommentsResponse>(apiEndpoints.jobs_notes_comments + job_notes_comments_id + '/').pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    )
  }

  getNotesCommentsList(job_notes_id: string, page: number, limit: number): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.get<jobsNotesCommentsResponse>(apiEndpoints.jobs_notes_comments + `?job_notes_id=${job_notes_id}&page=${page}&limit=${limit}`).pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    )
  }

  deleteInvoiceNotesComments(job_notes_comments_id: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobs_notes_comments + job_notes_comments_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  //jobs-Task-Notes-Comments
  tasknotesAddComments(notes: jobsNotesCommentsRequest): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.post<jobsNotesCommentsResponse>(apiEndpoints.jobs_task_notes_comments, notes).pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  taskupdatejobNotesComments(job_task_notes_comments_id: number, notes: any): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.put<jobsNotesCommentsResponse>(apiEndpoints.jobs_task_notes_comments + job_task_notes_comments_id + `/`, notes).pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  taskgetNotesComments(job_task_notes_comments_id: jobsNotesCommentsResponse): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.get<jobsNotesCommentsResponse>(apiEndpoints.jobs_task_notes_comments + job_task_notes_comments_id + '/').pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    )
  }

  taskgetNotesCommentsList(job_task_notes_id: string, page: number, limit: number): Observable<jobsNotesCommentsResponse> {
    return this.httpClient.get<jobsNotesCommentsResponse>(apiEndpoints.jobs_task_notes_comments + `?job_task_notes_id=${job_task_notes_id}&page=${page}&limit=${limit}`).pipe(
      map((response: jobsNotesCommentsResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    )
  }

  taskdeleteInvoiceNotesComments(job_task_notes_comments_id: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.jobs_task_notes_comments + job_task_notes_comments_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobfinincialList(job_id: any): Observable<jobsFinancialResponseModel> {
    return this.httpClient.get<jobsFinancialResponseModel>(apiEndpoints.job_financial_summary + `${job_id}/`).pipe(
      map((response: jobsFinancialResponseModel) =>
        response
      ),
      catchError((error: jobsFinancialResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  onNotesSelect(notes: any) {
    this.selectedNotes.next(notes);
  }

  getjobCount(): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_count).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobhistorylist(job_id: any, page: number, limit: number): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.job_history + `${job_id}/` + `?&page=${page}&limit=${limit}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsFinancialResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }

  multipleDeleteJobs(jobs: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.multiple_job_delete, jobs).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  multipleDeletetask(task: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.multiple_job_task_delete, task).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  multipleDeletecost(task: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.multiple_job_cost_delete, task).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  multipleDeletetimesheet(timesheet: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.multiple_timesheet_delete, timesheet).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  multipleDeletetodo(todo: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.multiple_job_task_todo_delete, todo).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createQuoteCustomField(customFields: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.jobs_custom_fields, customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateQuoteCustomField(customFields: any, client_id: any): Observable<any> {
    return this.httpClient.put<any>(apiEndpoints.jobs_custom_fields + client_id + '/', customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsTaskReoder(task: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.job_task_reorder, task).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsExpenseReoder(expense: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.job_cost_reorder, expense).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getJobsFilters(module: string): Observable<JobsFilterResponse> {
    return this.httpClient.get<JobsFilterResponse>(apiEndpoints.get_user_organization_filter + `?module=${module}`).pipe(
      map((response: JobsFilterResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  setJobsFilters(value: any): Observable<JobsFilterResponse> {
    return this.httpClient.post<JobsFilterResponse>(apiEndpoints.set_user_organization_filter, value).pipe(
      map((response: JobsFilterResponse) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  rateSource(postData: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.timesheet_rate, postData).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  clientJob(client_id: string,): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.client_job + `?client_id=${client_id}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getJobTimesheetFilters(module: string): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.get_user_organization_filter + `?module=${module}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  setJobTimesheetFilters(value: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.set_user_organization_filter, value).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobTimesheetsPatch(data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.timesheet_status_update, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobExpensePatch(data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.job_cost_status_update, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createTimesheetCustomField(customFields: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.timesheet_custom_fields, customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateTimesheetCustomField(customFields: any, timesheet_id: any): Observable<any> {
    return this.httpClient.put<any>(apiEndpoints.timesheet_custom_fields + timesheet_id + '/', customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createPhase(value: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.job_phase, value).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  patchPhase(value: any, phase_id: any): Observable<any> {
    return this.httpClient.put<any>(apiEndpoints.job_phase + phase_id + '/', value).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getPhaseDetails(phase_id: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_phase + phase_id + '/').pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deletePhase(value: any, phase_id: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.job_phase + phase_id + '/', value).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobMilestonesList(page: number, limit: number, job_id: any, phase_id: any): Observable<jobMilestonesResponseModel> {
    return this.httpClient.get<jobMilestonesResponseModel>(apiEndpoints.job_milestones + `?page=${page}&limit=${limit}&job_id=${job_id}&phase_id=${phase_id}`).pipe(
      map((response: jobMilestonesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createJobMilestone(job_milestone_request: jobMilestonesRequestModel): Observable<jobMilestonesResponseModel> {
    return this.httpClient.post<jobMilestonesResponseModel>(apiEndpoints.job_milestones, job_milestone_request).pipe(
      map((response: jobMilestonesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateJobMilestone(job_milestone_id: any, job_milestone_request: jobMilestonesRequestModel): Observable<jobMilestonesResponseModel> {
    return this.httpClient.put<jobMilestonesResponseModel>(apiEndpoints.job_milestones + job_milestone_id + '/', job_milestone_request).pipe(
      map((response: jobMilestonesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteJobMilestone(job_milestone_id: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.job_milestones + job_milestone_id + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getJobMilestone(job_milestone_id: any): Observable<jobMilestonesResponseModel> {
    return this.httpClient.get<jobMilestonesResponseModel>(apiEndpoints.job_milestones + job_milestone_id + '/').pipe(
      map((response: jobMilestonesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  milestonesComplete(job_milestone_id: string, data: any): Observable<jobMilestonesResponseModel> {
    return this.httpClient.patch<jobMilestonesResponseModel>(apiEndpoints.job_milestones + job_milestone_id + '/', data).pipe(
      map((response: jobMilestonesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsTaskStaffList(jobid: any, jobTask: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_task_staff_allocation + `?job_id=${jobid}&job_task_id=${jobTask}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsTaskStaffAllocation(jobs: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.job_task_staff_allocation, jobs).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateJobSheduleDate(job_id: any, postData: any): Observable<jobsResponseModel> {
    return this.httpClient.patch<jobsResponseModel>(apiEndpoints.jobslist + job_id + `/`, postData).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getJobsPhaseDetails(job_id: any, phase_id: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_phase_items + `?job_id=${job_id}&phase_id=${phase_id}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createJobTaskCustomField(customFields: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.job_task_custom_fields, customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateJobTaskCustomField(customFields: any, task_id: any): Observable<any> {
    return this.httpClient.put<any>(apiEndpoints.job_task_custom_fields + task_id + '/', customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createJobCostCustomField(customFields: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.job_cost_custom_fields, customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateJobCostCustomField(customFields: any, cost_id: any): Observable<any> {
    return this.httpClient.put<any>(apiEndpoints.job_cost_custom_fields + cost_id + '/', customFields).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  // version -2
  getJobdetails(id: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_info_version2 + id + '/').pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobV2invoiceslist(page: number, limit: number, id: any): Observable<jobsResponseModel> {
    return this.httpClient.get<jobsResponseModel>(apiEndpoints.jobs_v2_invoice + `?page=${page}&limit=${limit}&job_id=${id}`).pipe(
      map((response: jobsResponseModel) =>
        response
      ),
      catchError((error: jobsResponseModel) => {
        throw new Error('something went wrong. Please try again later.')
      })
    )
  }
}
